import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldlayoutsSchemesEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldlayouts-schemes-edit',
	path: '/secure/admin/EditFieldLayoutScheme([!%]?[\\w]*).jspa',
};
